import {
    createNotification,
    INotificationProperties,
    Notification,
} from '@vfde-brix/ws10/notification';
import {
    IPatternWithNoPatternBusinessLogic,
    NO_PATTERN_BUSINESS_LOGIC,
} from '@vfde-brix/ws10/core';
import { CLASSNAME_HIDDEN } from '@vfde-brix/ws10/styles';
import { startAppListening } from '../container/App/listener';
import {
    selectError,
    selectHasError,
} from '../container/App/slice';

/**
 * Mount notification
 */
export default function mountNotification (
    id: string,
    properties: INotificationProperties | IPatternWithNoPatternBusinessLogic = NO_PATTERN_BUSINESS_LOGIC,
): Notification | null {
    const container = document.getElementById(id);

    if (!container) {
        return null;
    }

    const notification = createNotification(container, properties);

    scrollIntoViewOnBasketError(container);

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectHasError(currentState) !== selectHasError(previousState),
        effect: (_action, api) => {
            api.cancelActiveListeners();

            const error = selectError(api.getState());

            if (error) {
                const { headline, subline } =
                    window.additionalPageOptions.errors[error.type];

                notification?.update({
                    stdHeadline: headline,
                    txtContent: subline,
                });
            }

            notification?.toggleContainer(!selectHasError(api.getState()));
        },
    });

    return notification;
}

const scrollIntoViewOnBasketError = (container: HTMLElement): void => {
    // Options for the observer (which mutations to observe)
    const config = { attributes: true };

    // Callback function to execute when mutations are observed
    const callback = (mutationList: MutationRecord[]) => {
        for (const mutation of mutationList) {
            const target = mutation.target as HTMLElement;

            if (mutation.type === 'attributes' && mutation.attributeName === 'class' && !target.classList.contains(CLASSNAME_HIDDEN)) {
                target.scrollIntoView({ block: 'end', behavior: 'smooth' });
            }
        }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(container, config);
};
